import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { CertificadoService } from '../../shared/service/certificado/certificado.service';
import { Login } from '../../shared/index';
import { TourService } from 'ngx-tour-ngx-popper';
import { TourState } from 'ngx-tour-core';

declare var $: any;

@Component({
    selector: 'app-cadastro-pin',
    templateUrl: './cadastro-pin.component.html',
    styleUrls: ['./cadastro-pin.component.css']
})
export class CadastroPinComponent implements OnInit {

    @Input() statusFatores: any = {};
    @Input() regex: string = "";
    @Input() descricaoRegex: string = "";
    @Output() enviaMensagemSucesso = new EventEmitter();
    @Output() enviaNovoCodigoChave = new EventEmitter();
    public pin: string;
    public confirmaPin: string;
    public usuarioId: number;
    public pinSuccesfullySet: boolean = false;
    public errorMessage: string;
    public disabledSalvarSubmit: boolean = false;

    @ViewChild('f', { static: true }) form;

    constructor(
        private certificadoService: CertificadoService,
        public tourService: TourService) {

    }

    ngOnInit() {
        this.usuarioId = JSON.parse(localStorage.getItem("currentUser")).id;
    }

    definirSenha() {
        this.disabledSalvarSubmit = true;
        let login: Login = new Login();
        login.senha = this.pin;
        this.certificadoService.definirSenha(this.usuarioId, login).subscribe(
            res => {
                this.pinSuccesfullySet = true;
                this.statusFatores.usuarioCadastrouPin = true;
                this.enviaNovoCodigoChave.emit(res.codigoChave);
                this.enviaMensagemSucesso.emit('PIN cadastrado com sucesso.');
                $('#modalCadastrarPin').modal('hide');
            },
            err => {
                this.disabledSalvarSubmit = false;
                this.errorMessage = err.message;
            }
        );
    }

    resetForm() {
        if (this.form) {
            this.form.resetForm();
            if (this.tourService.getStatus() == TourState.ON) {
                this.tourService.goto(this.tourService.currentStep.stepId);
            }
        }
    }

    prosseguir() {
        this.resetForm();

        if (this.tourService.getStatus() == TourState.ON) {
            this.tourService.next();
        }
        $('#modalCadastrarPin').modal('hide');
    }
}